import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import SurveyResponseAnswer from '@/models/SurveyResponseAnswer.js'

export const useSurveyResponseAnswerStore = defineStore('surveyResponseAnswerStore', () => {
  let syncableModel = useSyncableModel(useApiResource('survey_response_answers'), {
    className: SurveyResponseAnswer.modelName.name, 
    paramKey: SurveyResponseAnswer.modelName.paramKey 
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
